import React, { useState } from 'react';
import { Provider } from 'react-redux';
import { store } from './store';
import { CanvasBoard } from './CanvasBoard';
import { Sidebar, Timeline } from './UI';

const App: React.FC = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    return (
        <Provider store={store}>
            <div className="flex flex-col h-screen overflow-hidden">
                <header className="bg-white text-gray-900 h-14 md:h-20 px-4 md:px-6 flex justify-between items-center z-20 shadow-sm border-b border-gray-200 shrink-0">
                    <div className="h-full py-1 md:py-2">
                        <img
                            src="https://junkyard.2xk.cz/elektronicka-tuzka-narodni-hazene/logo-epencil.png"
                            alt="Sports Tactic Board"
                            className="h-full w-auto object-contain"
                        />
                    </div>
                    <div className="flex gap-4 items-center">
                        <button onClick={() => setIsSidebarOpen(!isSidebarOpen)} className="md:hidden bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded shadow">
                            {isSidebarOpen ? 'Close Tools' : 'Open Tools'}
                        </button>
                    </div>
                </header>

                <div className="flex flex-1 overflow-hidden relative flex-col md:flex-row">
                    <div className={`${isSidebarOpen ? 'absolute left-0 top-0 bottom-0 z-10' : 'hidden'} md:block md:static md:h-full`}>
                        <Sidebar />
                    </div>
                    {isSidebarOpen && <div className="absolute inset-0 bg-black bg-opacity-50 z-0 md:hidden" onClick={() => setIsSidebarOpen(false)}></div>}
                    <CanvasBoard />
                </div>
                <Timeline />
            </div>
        </Provider>
    );
};

export default App;